module.exports = __webpack_public_path__ + "img/balance.11f7f440.png";